//@flow
import * as React from 'react';
import type {buttonType, children, disabled, id, onClick} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import './BtnUpload.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children,
  onClick?: onClick,
  disabled?: disabled,
  buttonType?: buttonType
};

const BtnUpload = (props: Props) => {
  const buttonType = props.buttonType ? props.buttonType : 'button';
  return (
    <button type={buttonType} id={props.id} onClick={props.onClick} disabled={props.disabled}
            className={baseClass("BtnUpload pr_2du pl_6du", props.addClasses)}>
      {props.children}</button>
  );
};

export default BtnUpload;